/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { IErrorProps } from "../../models";

const getErrorForUserPages = (err: any) => {
  const error: IErrorProps = {
    errorCode: err.response?.status,
    errorMessage:
      typeof err?.response?.data === "string"
        ? err?.response?.data
        : typeof err?.response?.statusText === "string"
        ? err.response.statusText
        : "",
  };
  if (
    error.errorMessage === "" &&
    typeof err?.response?.data?.title === "string"
  ) {
    error.errorMessage = err.response.data.title;
  }
  return error;
};
export default getErrorForUserPages;
